import React from 'react';
import DetailsPortal from './DetailsPortal';
import './OrderDetailsPanel.css';

const MessageDetailsPanel = ({ message, onClose }) => {
  if (!message) return null;

  const formatValue = (value) => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'object') return JSON.stringify(value, null, 2);
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    return String(value);
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return '-';
    try {
      const date = new Date(timestamp * 1000);
      if (isNaN(date.getTime())) {
        const date2 = new Date(timestamp);
        if (isNaN(date2.getTime())) return String(timestamp);
        return formatCustomDate(date2);
      }
      return formatCustomDate(date);
    } catch {
      return String(timestamp);
    }
  };

  const formatCustomDate = (date) =>
    `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()} ${String(
      date.getHours()
    ).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;

  // Format Status
  const getStatus = () => {
    const status = (message.Status || message.status || '').toLowerCase();
    return { status, text: message.Status || message.status || '-' };
  };

  // Get all fields to display (excluding service fields)
  const getAllFields = () => {
    const fields = [];
    const excludeKeys = ['ref', 'create_time', 'change_time', 'status', 'Status'];
    
    Object.keys(message).forEach(key => {
      if (!excludeKeys.includes(key)) {
        fields.push({
          key,
          label: key,
          value: formatValue(message[key])
        });
      }
    });
    return fields;
  };

  const status = getStatus();
  const created = formatDate(message.create_time || message.Created || message.created);
  const changed = formatDate(message.change_time);
  const title = formatValue(message.title || message.Title || message.subject || message.Subject || message.message || message.Message || 'Message');
  const fieldsToShow = getAllFields();

  return (
    <DetailsPortal>
    <div className="order-details-overlay" onClick={onClose}>
      <div className="order-details-panel" onClick={(e) => e.stopPropagation()}>
        <div className="order-details-header">
          <h2>Message Details</h2>
          <button type="button" className="close-button" onClick={onClose}>Close</button>
        </div>
        <div className="order-details-content">
          <div className="order-summary">
            <div className="summary-main">
              <span className="summary-label">Message</span>
              <span className="summary-primary">{title}</span>
              <span className="summary-secondary">{created}</span>
            </div>
            <div className="summary-chips">
              <span className={`status-badge status-${status.status}`}>{status.text}</span>
            </div>
          </div>

          <div className="detail-section">
            <h3>Details</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <span className="detail-label">Status</span>
                <span className="detail-value">
                  <span className={`status-badge status-${status.status}`}>{status.text}</span>
                </span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Created</span>
                <span className="detail-value">{created}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Last Changed</span>
                <span className="detail-value">{changed}</span>
              </div>
              {fieldsToShow.map((field) => (
                <div key={field.key} className="detail-item">
                  <span className="detail-label">{field.label}</span>
                  <span className="detail-value">{field.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
    </DetailsPortal>
  );
};

export default MessageDetailsPanel;
